var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgUna = function SvgUna(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#una_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bfbdb3",
    stroke: "currentColor",
    d: "M25.024.5c1.29 0 2.451.53 3.282 1.382l.005.006 9.742 9.672.006.005a4.5 4.5 0 0 1 1.39 3.23.6.6 0 0 0 .032.18 4.5 4.5 0 0 1-1.14 2.875 3.5 3.5 0 0 0-.849 1.846c-.086.678.056 1.414.604 1.96l.006.005a4.5 4.5 0 0 1 .248 6.25 3.5 3.5 0 0 0-.85 1.845c-.081.636.039 1.323.506 1.855l.097.105.006.006a4.5 4.5 0 0 1 1.391 3.253c0 2.495-2.04 4.525-4.562 4.525H14.933c-1.29 0-2.451-.53-3.282-1.382l-.005-.006-9.742-9.672-.006-.005-.157-.159a4.496 4.496 0 0 1-.09-6.09 3.5 3.5 0 0 0 .849-1.847c.087-.678-.056-1.414-.604-1.96l-.005-.005-.158-.158a4.496 4.496 0 0 1-.088-6.09 3.5 3.5 0 0 0 .852-1.842c.088-.677-.053-1.413-.6-1.957l-.006-.006-.158-.158A4.5 4.5 0 0 1 .5 5.068C.5 2.652 2.414.667 4.833.51L5.069.5z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M34.363 33.16a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M34.688 31.875a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "m17.829 5.676-.108.3c-.08.222.005.47.204.596l6.492 4.14c.363.232.583.634.583 1.066v4.482a1.26 1.26 0 0 1-.943 1.222l-8.673 2.24 5.147 2.98c.156.09.252.256.252.436v1.357a.503.503 0 0 1-.643.485L8.02 21.438a1.26 1.26 0 0 1-.906-1.212v-3.1c0-.543.345-1.025.857-1.197l4.774-1.606a.5.5 0 0 1 .284-.01l8.021 2.056-6.013-2.725a.5.5 0 0 0-.109-.035l-4.483-.894-3.959-1.118a.5.5 0 0 1-.32-.273l-1.12-2.416a.51.51 0 0 1 .099-.567l.42-.43a.5.5 0 0 1 .314-.148l1.892-.17a.1.1 0 0 0 .039-.011l5.395-2.415a.5.5 0 0 1 .189-.043L17.34 5a.504.504 0 0 1 .489.676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "una_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))))));
};
export default SvgUna;